import { render, staticRenderFns } from "./ClientsHistory.vue?vue&type=template&id=395963af"
import script from "./ClientsHistory.vue?vue&type=script&lang=ts"
export * from "./ClientsHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports